<template>
  <div class="layout-dashboard">
    <SidebarOverlay v-if="opened" />
    <Header :fullHeader="false" :containerFluid="true"></Header>

    <b-container fluid>
      <div class="d-flex flex-nowrap justify-content-center position-relative">
        <nav
          class="layout-dashboard-sidebar bg-light sidebar dashboard-sidebar"
          :class="{ opened }"
        >
          <Sidebar></Sidebar>
        </nav>
        <main class="layout-dashboard-main py-3 px-md-4">
          <router-view />
        </main>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Sidebar from '@/components/dashboard/Sidebar';
import SidebarOverlay from '@/components/dashboard/SidebarOverlay';

export default {
  components: {
    Header,
    Sidebar,
    SidebarOverlay
  },
  computed: {
    error() {
      return this.$store.getters.error;
    },
    opened() {
      return this.$store.getters.sidebarOpened;
    }
  },
  watch: {
    error(fbError) {
      this.$toast(fbError || 'Что-то пошло не так', {
        title: 'Ошибка',
        variant: 'warning'
      });
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch('userData');
    } catch (e) {
      //
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/styles/modules/layout-dashboard';

.layout-dashboard-sidebar {
  flex-shrink: 0;
  width: var(--dashboard-sidebar-width);
  min-height: calc(100vh - var(--layout-padding));
}

.layout-dashboard-main {
  width: 1200px;
}

.dashboard-sidebar__inner {
  position: fixed;
  width: var(--dashboard-sidebar-width);
}
</style>
